import { render } from "./SelecionarPlanoConta.vue?vue&type=template&id=d3310748&scoped=true&ts=true"
import script from "./SelecionarPlanoConta.vue?vue&type=script&lang=ts"
export * from "./SelecionarPlanoConta.vue?vue&type=script&lang=ts"

import "./SelecionarPlanoConta.vue?vue&type=style&index=0&id=d3310748&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3310748"]])

export default __exports__